(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) {
        console.warn('StickyHeader: .section-header not found');
        return;
      }

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always add sticky class to enable hide/show functionality
      this.header.classList.add('shopify-section-header-sticky');

      // Ensure transition is applied
      this.header.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';

      this.currentScrollTop = 0;
      this.lastScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = 50; // Hide header after scrolling down 50px

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // At the top of the page - always show header
      if (scrollTop <= scrollThreshold) {
        this.header.classList.remove('scrolled-past-header', 'header-scrolled-down');
        this.header.style.transform = 'translateY(0)';
        this.currentScrollTop = scrollTop;
        this.lastScrollTop = scrollTop;
        return;
      }

      // Determine scroll direction
      const scrollingDown = scrollTop > this.lastScrollTop;
      const scrollingUp = scrollTop < this.lastScrollTop;

      // Scrolling down - hide header
      if (scrollingDown && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header', 'header-scrolled-down');
        const headerHeight = this.header.offsetHeight || 80;
        this.header.style.transform = `translateY(-${headerHeight}px)`;
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }
      // Scrolling up - show header
      else if (scrollingUp) {
        this.header.classList.add('scrolled-past-header');
        this.header.classList.remove('header-scrolled-down');
        this.header.style.transform = 'translateY(0)';
      }

      this.currentScrollTop = scrollTop;
      this.lastScrollTop = scrollTop;
    }

    hide() {
      if (!this.header) return;
      // Ensure sticky and animate classes are present
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      // Add hidden class to trigger the CSS transform
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header) return;
      // Ensure sticky and animate classes are present
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      // Remove hidden class to show the header
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate', 'header-scrolled-down');
      this.header.style.transform = 'translateY(0)';
      // Keep sticky class
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Simple header hide on scroll functionality
  (function () {
    let lastScrollTop = 0;
    let ticking = false;
    let hasScrolledPastThreshold = false; // Track if we've ever scrolled past threshold
    // ADJUST THIS VALUE to change when header starts hiding (in pixels)
    // Lower value = hides sooner, Higher value = hides later
    const scrollThreshold = 50;

    // ADJUST THIS VALUE to change how much the header hides (in pixels)
    // Higher value = hides more (moves further up), Lower value = hides less
    // Default is 0 (hides by header height only). Add extra pixels to hide more.
    const hideOffset = 100;

    const header = document.querySelector('.section-header');
    if (!header) return;

    const headerWrapper = header.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    // Find the first section after header (hero section)
    // Also treats product pages (main-product.liquid) as hero sections
    function getHeroSection() {
      // Check if we're on a product page - treat product-info as hero section
      const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      if (productInfo) {
        return productInfo;
      }

      // Otherwise, find the first section after header
      const sections = document.querySelectorAll('.shopify-section:not(.section-header)');
      if (sections.length > 0) {
        return sections[0];
      }
      return null;
    }

    // Check if header has scrolled past hero section
    function isPastHeroSection() {
      const heroSection = getHeroSection();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isTransparentHeader = headerWrapper.classList.contains('header-wrapper--transparent-top');

      // If no hero section, check if header should be transparent
      if (!heroSection) {
        // If header is set to be transparent and we're at the top, don't add past-hero class
        if (isTransparentHeader && scrollTop <= scrollThreshold) {
          return false;
        }
        // Otherwise, show background (past hero)
        return true;
      }

      const heroSectionTop = heroSection.getBoundingClientRect().top + scrollTop;
      const headerHeight = header.offsetHeight || 80;

      // Check if we've scrolled past the hero section
      return scrollTop > heroSectionTop + heroSection.offsetHeight - headerHeight;
    }

    // Ensure header has proper positioning
    header.style.position = 'sticky';
    header.style.top = '0';
    header.style.transition = 'transform 0.3s ease-in-out';
    header.style.zIndex = '110';

    function isInlineMenuVisible() {
      const inlineMenu = header.querySelector('.header__inline-menu');
      if (!inlineMenu) return false;

      // Check if inline menu has background color (not transparent)
      const computedStyle = window.getComputedStyle(inlineMenu);
      const bgColor = computedStyle.backgroundColor;

      // Check if background is not transparent
      if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
        // Check if it's actually visible (not just set but transparent)
        const rgbMatch = bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
        if (rgbMatch) {
          const alpha = rgbMatch[4] ? parseFloat(rgbMatch[4]) : 1;
          if (alpha > 0) {
            return true;
          }
        } else if (bgColor !== 'transparent' && bgColor !== 'rgba(0, 0, 0, 0)') {
          return true;
        }
      }

      // Check if any menu items are active or hovered
      const activeItems = inlineMenu.querySelectorAll('.menu-item-active');
      if (activeItems.length > 0) return true;

      // Check if menu is hovered
      if (inlineMenu.classList.contains('menu-hovered')) return true;

      // Check if any list items are being hovered
      const hoveredItems = inlineMenu.querySelectorAll('.list-menu--inline li:hover');
      if (hoveredItems.length > 0) return true;

      return false;
    }

    function updateHeader() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isTransparentHeader = headerWrapper.classList.contains('header-wrapper--transparent-top');
      const heroSection = getHeroSection();
      const scrollingUp = scrollTop < lastScrollTop;

      // Track if we've scrolled past the threshold
      if (scrollTop > scrollThreshold) {
        hasScrolledPastThreshold = true;
      } else if (scrollTop <= 10) {
        // Reset flag only when at the very top
        hasScrolledPastThreshold = false;
      }

      // Show/hide background based on hero section
      // Special handling for pages without hero section but with transparent header
      if (!heroSection && isTransparentHeader) {
        // On pages without hero section, show background when:
        // 1. Currently scrolled past threshold, OR
        // 2. We've scrolled past threshold before and not yet at the very top (for scroll up behavior)
        if (scrollTop > scrollThreshold || (hasScrolledPastThreshold && scrollTop > 10)) {
          headerWrapper.classList.add('header-past-hero');
        } else {
          // At top of page - remove past-hero to allow transparency
          headerWrapper.classList.remove('header-past-hero');
        }
      } else if (isPastHeroSection()) {
        // Past hero section - show background
        headerWrapper.classList.add('header-past-hero');
      } else {
        // Over hero section - remove past-hero class to allow transparency
        headerWrapper.classList.remove('header-past-hero');
      }

      // Don't hide if at top of page
      if (scrollTop <= scrollThreshold && !scrollingUp) {
        header.style.transform = 'translateY(0)';
        lastScrollTop = scrollTop;
        ticking = false;
        return;
      }

      // Don't hide if inline menu background is visible
      if (isInlineMenuVisible()) {
        header.style.transform = 'translateY(0)';
        lastScrollTop = scrollTop;
        ticking = false;
        return;
      }

      // Scrolling down - hide header
      if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
        const headerHeight = header.offsetHeight || 80;
        const totalHide = headerHeight + hideOffset;
        header.style.transform = `translateY(-${totalHide}px)`;
      }
      // Scrolling up - show header
      else if (scrollTop < lastScrollTop) {
        header.style.transform = 'translateY(0)';
      }

      lastScrollTop = scrollTop;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Initialize background state
    function initBackground() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isTransparentHeader = headerWrapper.classList.contains('header-wrapper--transparent-top');
      const heroSection = getHeroSection();

      // Initialize hasScrolledPastThreshold flag
      if (scrollTop > scrollThreshold) {
        hasScrolledPastThreshold = true;
      } else {
        hasScrolledPastThreshold = false;
      }

      // Special handling for pages without hero section but with transparent header
      if (!heroSection && isTransparentHeader) {
        // On pages without hero section, only add past-hero when scrolled down
        if (scrollTop > scrollThreshold) {
          headerWrapper.classList.add('header-past-hero');
        } else {
          // At top of page - remove past-hero to allow transparency
          headerWrapper.classList.remove('header-past-hero');
        }
      } else if (isPastHeroSection()) {
        headerWrapper.classList.add('header-past-hero');
      } else {
        headerWrapper.classList.remove('header-past-hero');
      }
    }

    // Initialize on load and after a short delay to ensure DOM is ready
    initBackground();
    setTimeout(initBackground, 100);

    // Also initialize on scroll
    updateHeader();
  })();

  // Overlay transition management
  (function () {
    const overlay = document.querySelector('.header__inline-overlay');
    if (!overlay) return;

    let overlayTimeout = null;
    let transitionEndHandler = null;
    const transitionDuration = 300; // Match CSS transition duration

    function showOverlay() {
      // Clear any pending hide
      if (overlayTimeout) {
        clearTimeout(overlayTimeout);
        overlayTimeout = null;
      }

      // Remove transition end handler if exists
      if (transitionEndHandler) {
        overlay.removeEventListener('transitionend', transitionEndHandler);
        transitionEndHandler = null;
      }

      // Set display first
      overlay.style.display = 'block';
      overlay.style.opacity = '0';

      // Use requestAnimationFrame to ensure display is applied before opacity transition
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
          overlay.classList.add('overlay-visible');
        });
      });
    }

    function hideOverlay() {
      // Clear any pending show
      if (overlayTimeout) {
        clearTimeout(overlayTimeout);
        overlayTimeout = null;
      }

      // Remove visible class first
      overlay.classList.remove('overlay-visible');

      // Remove any existing transition end handler
      if (transitionEndHandler) {
        overlay.removeEventListener('transitionend', transitionEndHandler);
      }

      // Create new transition end handler
      transitionEndHandler = function (e) {
        // Only handle opacity transitions
        if (e.propertyName === 'opacity') {
          overlay.style.display = 'none';
          overlay.removeEventListener('transitionend', transitionEndHandler);
          transitionEndHandler = null;
        }
      };

      // Use requestAnimationFrame to ensure the class removal is processed
      // Then trigger the opacity transition
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Start opacity transition
          overlay.style.opacity = '0';

          // Listen for transition end
          overlay.addEventListener('transitionend', transitionEndHandler);

          // Fallback timeout in case transitionend doesn't fire
          overlayTimeout = setTimeout(() => {
            overlay.style.display = 'none';
            if (transitionEndHandler) {
              overlay.removeEventListener('transitionend', transitionEndHandler);
              transitionEndHandler = null;
            }
            overlayTimeout = null;
          }, transitionDuration + 50); // Add small buffer
        });
      });
    }

    // Check if overlay should be visible
    function shouldShowOverlay() {
      const header = document.querySelector('.header');
      if (!header) return false;

      // Check if any spans within menu items are hovered
      const hoveredSpans = header.querySelectorAll(
        '.list-menu--inline li span:hover, .list-menu--inline li[data-custom-menu-id] span:hover'
      );
      if (hoveredSpans.length > 0) return true;

      // Check if any menu items are active
      const activeItems = header.querySelectorAll('.list-menu--inline li.menu-item-active');
      if (activeItems.length > 0) return true;

      // Check if menu is hovered
      const inlineMenu = header.querySelector('.header__inline-menu');
      if (inlineMenu && inlineMenu.classList.contains('menu-hovered')) return true;

      return false;
    }

    // Monitor for changes
    function checkOverlayState() {
      if (shouldShowOverlay()) {
        showOverlay();
      } else {
        hideOverlay();
      }
    }

    // Listen for hover events on menu item spans
    const header = document.querySelector('.header');
    if (header) {
      const menuSpans = header.querySelectorAll(
        '.list-menu--inline li span, .list-menu--inline li[data-custom-menu-id] span'
      );
      menuSpans.forEach((span) => {
        span.addEventListener('mouseenter', checkOverlayState);
        span.addEventListener('mouseleave', checkOverlayState);
      });

      // Listen for menu hover
      const inlineMenu = header.querySelector('.header__inline-menu');
      if (inlineMenu) {
        inlineMenu.addEventListener('mouseenter', checkOverlayState);
        inlineMenu.addEventListener('mouseleave', checkOverlayState);
      }

      // Use MutationObserver to watch for menu-item-active class changes
      const observer = new MutationObserver(checkOverlayState);
      if (inlineMenu) {
        observer.observe(inlineMenu, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      // Listen for custom overlay-check events
      document.addEventListener('overlay-check', checkOverlayState);
    }

    // Initial check
    checkOverlayState();
  })();

  // Menu item hover persistence
  (function () {
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    // Track when cursor is on the inline menu for persistent fixed position
    inlineMenu.addEventListener('mouseenter', function () {
      this.classList.add('menu-hovered');
    });

    // Get all spans within list items in the inline menu (including custom menu items, children, and grandchildren)
    const menuSpans = inlineMenu.querySelectorAll(
      '.list-menu--inline li span, .list-menu--inline li[data-custom-menu-id] span, li[data-custom-child-id] span, .header__inline-menu__col-3 li span'
    );
    let activeItems = new Map();
    let activeParentId = null;

    // Function to update box visibility - only show box on hovered/active item
    function updateBoxVisibility(activeLi) {
      // Remove box-visible from all menu items
      const allMenuItems = inlineMenu.querySelectorAll(
        '.list-menu--inline li, .header__inline-menu__col-2 li, .header__inline-menu__col-3 li'
      );
      allMenuItems.forEach((li) => {
        li.classList.remove('box-visible');
      });

      // Add box-visible to the active item
      if (activeLi) {
        activeLi.classList.add('box-visible');

        // If hovering a child or grandchild, check if parent custom item is active
        // If parent is active, keep its box visible too
        if (activeLi.hasAttribute('data-custom-child-id') || activeLi.closest('.header__inline-menu__col-3')) {
          // This is a child or grandchild item
          // Check if there's an active parent custom item
          const activeParent = inlineMenu.querySelector('li[data-custom-menu-id].menu-item-active');
          if (activeParent) {
            activeParent.classList.add('box-visible');
          }
        }
      } else {
        // If no active item, check if there's an active parent custom item
        const activeParent = inlineMenu.querySelector('li[data-custom-menu-id].menu-item-active');
        if (activeParent) {
          activeParent.classList.add('box-visible');
        }
      }
    }

    menuSpans.forEach((span) => {
      span.addEventListener('mouseenter', function () {
        const parentLi = this.closest('li');
        if (!parentLi) return;

        // Update box visibility
        updateBoxVisibility(parentLi);

        // Determine the item type
        let itemType = 'default';
        let isCustomItem = false;
        let isChildOfActiveParent = false;
        let isGrandchildOfActiveChild = false;

        if (parentLi.hasAttribute('data-custom-menu-id')) {
          itemType = 'parent';
          isCustomItem = true;
          const parentId = parentLi.getAttribute('data-custom-menu-id');
          activeParentId = parentId;

          // Show the specific child menu for this parent
          inlineMenu.querySelectorAll('.header__inline-menu__child-menu').forEach((childMenu) => {
            if (childMenu.getAttribute('data-parent-id') === parentId) {
              childMenu.classList.add('child-menu-active');
            } else {
              childMenu.classList.remove('child-menu-active');
            }
          });

          // Clear grandchild menus when switching parents
          inlineMenu.querySelectorAll('.header__inline-menu__grandchild-menu').forEach((grandchildMenu) => {
            grandchildMenu.classList.remove('grandchild-menu-active');
          });
        } else if (parentLi.hasAttribute('data-custom-child-id')) {
          itemType = 'child';
          const childId = parentLi.getAttribute('data-custom-child-id');

          // Check if this child belongs to the active parent
          const childMenu = inlineMenu.querySelector(
            `.header__inline-menu__child-menu[data-parent-id="${activeParentId}"]`
          );
          if (childMenu) {
            const childLiInMenu = childMenu.querySelector(`li[data-custom-child-id="${childId}"]`);
            if (childLiInMenu) {
              isChildOfActiveParent = true;
            }
          }

          if (isChildOfActiveParent) {
            // Show the specific grandchild menu for this child
            inlineMenu.querySelectorAll('.header__inline-menu__grandchild-menu').forEach((grandchildMenu) => {
              if (grandchildMenu.getAttribute('data-parent-child-id') === childId) {
                grandchildMenu.classList.add('grandchild-menu-active');
              } else {
                grandchildMenu.classList.remove('grandchild-menu-active');
              }
            });
          } else {
            // Clear all grandchild menus if child doesn't belong to active parent
            inlineMenu.querySelectorAll('.header__inline-menu__grandchild-menu').forEach((grandchildMenu) => {
              grandchildMenu.classList.remove('grandchild-menu-active');
            });
          }
        } else {
          // Regular menu item or other item - check if it's a grandchild
          const grandchildMenu = parentLi.closest('.header__inline-menu__grandchild-menu');
          if (grandchildMenu) {
            // This is a grandchild item
            const grandchildParentId = grandchildMenu.getAttribute('data-parent-child-id');
            // Check if this grandchild belongs to an active child
            const activeChild = activeItems.get('child');
            if (activeChild && activeChild.getAttribute('data-custom-child-id') === grandchildParentId) {
              isGrandchildOfActiveChild = true;
            }
          }
        }

        // If hovering an item that's not part of the active custom menu hierarchy, clear custom menu active states
        if (!isCustomItem && !isChildOfActiveParent && !isGrandchildOfActiveChild) {
          // Clear all custom menu item active states
          inlineMenu.querySelectorAll('li[data-custom-menu-id].menu-item-active').forEach((item) => {
            item.classList.remove('menu-item-active');
          });
          inlineMenu.querySelectorAll('li[data-custom-child-id].menu-item-active').forEach((item) => {
            item.classList.remove('menu-item-active');
          });
          inlineMenu.querySelectorAll('.child-menu-active, .grandchild-menu-active').forEach((menu) => {
            menu.classList.remove('child-menu-active', 'grandchild-menu-active');
          });
          if (activeItems.has('parent')) {
            activeItems.delete('parent');
          }
          if (activeItems.has('child')) {
            activeItems.delete('child');
          }
          activeParentId = null;
        }

        // Remove active class from previous item of the same type
        if (activeItems.has(itemType)) {
          const previousItem = activeItems.get(itemType);
          if (previousItem !== parentLi) {
            previousItem.classList.remove('menu-item-active');
          }
        }

        // Add active class to current item's parent li
        parentLi.classList.add('menu-item-active');
        activeItems.set(itemType, parentLi);

        // Update box visibility for active item
        // If this is a child/grandchild and parent is active, show both boxes
        updateBoxVisibility(parentLi);

        // If parent custom item is active, ensure its box stays visible
        if (isChildOfActiveParent || isGrandchildOfActiveChild) {
          const activeParent = inlineMenu.querySelector('li[data-custom-menu-id].menu-item-active');
          if (activeParent) {
            activeParent.classList.add('box-visible');
          }
        }

        // Trigger overlay check
        const event = new CustomEvent('overlay-check');
        document.dispatchEvent(event);
      });
    });

    // Remove active class when mouse leaves the entire menu area
    inlineMenu.addEventListener('mouseleave', function () {
      this.classList.remove('menu-hovered');
      inlineMenu.querySelectorAll('.menu-item-active').forEach((item) => {
        item.classList.remove('menu-item-active');
      });
      inlineMenu.querySelectorAll('.child-menu-active, .grandchild-menu-active').forEach((menu) => {
        menu.classList.remove('child-menu-active', 'grandchild-menu-active');
      });
      activeItems.clear();
      activeParentId = null;

      // Remove box visibility when leaving menu
      updateBoxVisibility(null);

      // Trigger overlay check
      const event = new CustomEvent('overlay-check');
      document.dispatchEvent(event);
    });
  })();

  // Watch for cart drawer open/close to update header styling
  (function () {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Use MutationObserver to watch for class changes on cart-drawer
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = cartDrawer.classList.contains('active');
          if (isActive) {
            document.body.classList.add('cart-drawer-open');
          } else {
            document.body.classList.remove('cart-drawer-open');
          }
        }
      });
    });

    // Start observing
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Check initial state
    if (cartDrawer.classList.contains('active')) {
      document.body.classList.add('cart-drawer-open');
    }
  })();

  // Detect if we're on the cart page and add class to body
  (function () {
    function checkCartPage() {
      const path = window.location.pathname;
      if (path === '/cart' || path.startsWith('/cart?')) {
        document.body.classList.add('cart-page-open');
      } else {
        document.body.classList.remove('cart-page-open');
      }
    }

    // Check on page load
    checkCartPage();

    // Check on navigation (for SPA-like navigation if applicable)
    window.addEventListener('popstate', checkCartPage);
  })();

  } catch(e) { console.error(e); }
})();
})();
